module.exports = __webpack_public_path__ + "static/media/coxinhabanner.b6a93ad4.webp";